import React from "react";
import { withStyles } from '@material-ui/core';
import Tooltip from "./Tooltip"

const styles = () => ({
  root: {
    border: "1px solid #dadada",
    background: "white",
    display: "flex",
    alignItems: "center",
    borderRight: "0px"
  },
  countSize: {
    fontSize: 32,
    lineHeight: "48px",
    fontWeight: 600,
    color: "rgba(51, 51, 51, 1)",
    marginTop: 6
  },
  label: {
    color: "rgba(51, 51, 51, 0.8)",
    opacity: "0.75",
    fontSize: 16,
    lineHeight: "24px"
  },
  cardContainer: {
    padding: "16px 32px",
    width: "100%",
    borderRight: "1px solid #dadada",
    "&:hover div": {
      color: "#26bbed !important"
    }
  }
})

const StatsDetails = ({ classes, count, label, tooltipText }) => {
  if (tooltipText) {
    return (
      <Tooltip tooltip_text={tooltipText}>
        <div className={classes.cardContainer}>
          <div className={classes.label}>{label} </div>
          <div className={classes.countSize} >{count}</div>
        </div>
      </Tooltip>
    )
  }
  return (
    <div className={classes.cardContainer}>
      <div className={classes.label}>{label} </div>
      <div className={classes.countSize} >{count}</div>
    </div>
  )
}


const OverviewDetails = ({ classes, topChart }) => {
  const renderCard = (item, index) => {
    return <StatsDetails {...item} classes={classes} key={index} />
  }
  return (
    <div className={classes.root}>
      {
        topChart.map(renderCard)
      }
    </div>
  )
}

export default withStyles(styles)(OverviewDetails)